const AcademicYearCurriculumProgramsMapTypePolicy = {
  AcademicYearCurriculumProgramsMap: {
    keyFields: ["academicYear", ["id"]],
  },
};

export default AcademicYearCurriculumProgramsMapTypePolicy;
